function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhychooseus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.36,
      fill: "#DADEEA"
    },
    cx: 210.404,
    cy: 190.005,
    r: 142.182
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.36,
      fill: "#7DBBF1"
    },
    cx: 250,
    cy: 444.316,
    rx: 195.743,
    ry: 13.044
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48BE97"
    },
    d: "M190.047,318.412c0,0-0.549-11.284-16.514-17.293C173.533,301.119,176.004,316.356,190.047,318.412 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48BE97"
    },
    d: "M188.779,338.365c0,0-1.659-14.561-22.831-20.999C165.948,317.366,170.427,336.884,188.779,338.365 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48BE97"
    },
    d: "M194.071,367.225c0,0-2.406-16.884-27.245-23.681C166.826,343.544,172.674,366.102,194.071,367.225 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48BE97"
    },
    d: "M211.415,397.486c0,0-9.413-18.242-40.336-16.143C171.078,381.343,186.648,404.672,211.415,397.486 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48BE97"
    },
    d: "M190.024,318.627c0,0,2.185-11.084,18.855-14.706C208.879,303.92,204.217,318.636,190.024,318.627z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48BE97"
    },
    d: "M188.375,338.551c0,0,3.76-14.165,25.644-17.453C214.019,321.098,206.747,339.756,188.375,338.551z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48BE97"
    },
    d: "M193.671,367.095c0,0-2.121-16.923,20.055-30.015C213.726,337.081,214.019,360.382,193.671,367.095 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48BE97"
    },
    d: "M210.052,397.673c0,0-8.279-18.783,12.781-41.524C222.833,356.148,231.202,382.918,210.052,397.673 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#48BE97",
      strokeWidth: 2.0108,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M190.28,318.066 c0,0-15.621,65.058,55.883,111.539"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48BE97"
    },
    d: "M308.086,339.287c0,0,2.105-11.099,18.749-14.841C326.835,324.445,322.279,339.194,308.086,339.287 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48BE97"
    },
    d: "M306.177,359.411c0,0,3.658-14.192,25.518-17.637C331.695,341.774,324.558,360.484,306.177,359.411 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48BE97"
    },
    d: "M297.53,386.597c0,0,8.789-14.616,34.314-11.207C331.845,375.39,317.677,393.892,297.53,386.597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48BE97"
    },
    d: "M276.89,414.645c0,0,14.908-14.11,43.404-1.919C320.294,412.727,297.895,429.606,276.89,414.645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48BE97"
    },
    d: "M308.079,339.502c0,0-0.63-11.28-16.638-17.174C291.441,322.328,294.021,337.547,308.079,339.502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48BE97"
    },
    d: "M306.185,359.355c0,0-1.763-14.549-22.981-20.834C283.204,338.521,287.822,358.006,306.185,359.355 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48BE97"
    },
    d: "M297.759,386.999c0,0,4.443-16.466-15.708-32.502C282.051,354.498,278.536,377.534,297.759,386.999 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48BE97"
    },
    d: "M277.303,415.015c0,0,10.799-17.457-6.91-42.894C270.393,372.121,258.399,397.475,277.303,415.015z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#48BE97",
      strokeWidth: 2.0108,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M307.904,338.912 c0,0,2.288,54.658-40.509,83.457"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36A871"
    },
    d: "M103.224,444.318c4.828-10.47,13.425-41.186,0.18-47.61c-8.306-4.028-10.745,2.87-10.745,2.87 s6.002-33.601-8.226-33.673c-8.296-0.042-9.695,9.482-9.695,9.482s-4.508-10.507-10.028-13.561 c-11.994-6.636-26.272,0.225-15.207,18.997c3,5.09,7.165,8.754,7.165,8.754s-12.504-4.711-13.727,4.232 c-1.223,8.943,22.479,23.146,22.479,23.146s-7.094,0.27-7.372,8.464c-0.377,11.072,22.479,18.898,22.479,18.898H103.224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.794,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M57.968,370.011 c15.547,22.794,28.319,29.567,38.715,72.015"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48BE97"
    },
    d: "M113.769,444.318c-0.511-15.564,22.462-47.899,8.547-55.74c-8.726-4.917-11.189,3.971-11.189,3.971 s19.656-33.308,0.85-35.54c-6.554-0.778-10.355,8.8-10.355,8.8s-0.158-17.149-5.407-23.573 c-8.563-10.48-26.484-4.623-22.257,17.97c2.318,12.391,10.831,17.296,10.831,17.296s-8.61-6.572-12.718,2.057 c-5.503,11.561,12.947,26.497,12.947,26.497s-8.256-6.116-13.711,3.887c-7.371,13.515,20.658,34.376,20.658,34.376H113.769z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.794,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M88.897,354.676 c10.523,26.721,16.008,56.04,18.28,87.014"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36A871"
    },
    d: "M390.146,444.318c3.42-12.638-13.061-37.536-0.259-43.903c8.028-3.992,12.342,0.091,12.342,0.091 s-9.452-25.096,6.234-26.908c5.467-0.632,7.124,4.24,7.124,4.24s2.172-7.432,8.034-12.096 c11.113-8.841,25.594-5.564,17.802,12.782c-4.273,10.061-7.648,11.536-7.648,11.536s7.724-1.496,9.39,5.51 c2.232,9.388-16.267,25.101-16.267,25.101s6.648,0.626,7.524,5.599c1.936,10.995-21.379,18.047-21.379,18.047H390.146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.7248,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M436.357,367.578 c-21.285,17.282-22.073,52.454-32.855,72.764"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48BE97"
    },
    d: "M380.525,444.318c-7.706-12.675-24.47-49.863-12.182-57.64c7.706-4.877,12.004,3.475,12.004,3.475 s-14.765-40.68,0.155-40.766c8.699-0.051,12.567,11.48,12.567,11.48s2.953-11.933,7.09-19.105 c9.522-16.506,31.853-9.914,23.971,16.285c-1.997,6.639-7.999,15.064-7.999,15.064s13.869-0.833,13.5,11.167 c-0.349,11.384-19.568,22.09-19.568,22.09s12.778-2.848,15.135,7.073c3.185,13.405-25.04,30.879-25.04,30.879H380.525z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.7248,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M413.504,348.343 c-10.737,36.383-26.467,41.81-26.69,93.201"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36A871"
    },
    d: "M250.111,349.872c0,0,0.87-7.708,12.071-11.127C262.182,338.745,259.823,349.077,250.111,349.872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36A871"
    },
    d: "M250.107,363.598c0,0,1.773-9.905,16.562-13.389C266.669,350.209,262.746,363.386,250.107,363.598z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36A871"
    },
    d: "M245.219,383.141c0,0,2.387-11.464,19.703-15.034C264.922,368.107,259.929,383.307,245.219,383.141 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36A871"
    },
    d: "M232.012,403.116c0,0,7.247-12.087,28.344-9.297C260.355,393.82,248.667,409.123,232.012,403.116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36A871"
    },
    d: "M250.117,350.019c0,0-1.012-7.69-12.275-10.901C237.842,339.118,240.392,349.405,250.117,350.019z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36A871"
    },
    d: "M250.376,363.743c0,0-1.957-9.87-16.807-13.08C233.569,350.664,237.735,363.766,250.376,363.743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36A871"
    },
    d: "M245.498,383.069c0,0,2.194-11.502-12.428-21.442C233.07,361.627,231.85,377.58,245.498,383.069z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36A871"
    },
    d: "M232.938,403.304c0,0,6.494-12.508-6.941-29.011C225.997,374.293,219.091,392.269,232.938,403.304z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#36A871",
      strokeWidth: 1.3805,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M249.967,349.624 c0,0,7.858,45.26-43.168,73.98"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#65A4DA"
    },
    d: "M251.334,444.318c-13.016,0-12.382,0-14.736,0c-10.245,0-26.194-28.709-26.194-39.837 c0-11.056,15.887-40.392,26.194-40.392c5.057,0,1.641,0,14.736,0c13.052,0,23.364,4.061,30.65,12.068 c7.003,7.708,10.551,17.236,10.551,28.324c0,11.161-3.592,20.642-10.674,28.179C274.576,440.399,264.308,444.318,251.334,444.318z  M212.354,329.431l0.227-11.525c0.392-19.893,3.089-35.422,8.247-47.477c5.208-12.173,15.169-24.95,30.45-39.062l0.238-0.214 l35.404-30.883c12.894-12.395,19.163-25.013,19.163-38.567c0-12.892-3.69-22.539-11.281-29.493 c-7.769-7.107-19.835-10.713-35.857-10.713c-15.931,0-28.669,3.443-37.862,10.233c-8.37,6.179-12.267,13.907-12.267,24.322v11.302 h-73.054l0.167-11.466c0.413-28.471,12.51-51.742,35.954-69.166c22.461-16.695,51.753-25.16,87.062-25.16 c36.752,0,66.085,8.711,87.185,25.89c21.793,17.751,32.842,42.258,32.842,72.843c0,30.085-16.092,59.634-47.829,87.825 l-0.243,0.21l-29.371,24.633c-10.808,10.282-16.062,25.059-16.062,45.166v11.302H212.354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7DBBF1"
    },
    d: "M236.598,444.318c-13.016,0-23.262-3.945-30.454-11.726c-6.952-7.525-10.477-16.983-10.477-28.111 c0-11.056,3.481-20.559,10.347-28.247c7.199-8.06,17.488-12.146,30.583-12.146c13.052,0,23.364,4.061,30.65,12.068 c7.003,7.708,10.551,17.236,10.551,28.324c0,11.161-3.592,20.642-10.674,28.179C259.84,440.399,249.572,444.318,236.598,444.318z  M197.618,329.431l0.227-11.525c0.392-19.893,3.089-35.422,8.247-47.477c5.209-12.173,15.169-24.95,30.45-39.062l0.238-0.214 l35.404-30.883c12.894-12.395,19.163-25.013,19.163-38.567c0-12.892-3.69-22.539-11.281-29.493 c-7.769-7.107-19.835-10.713-35.857-10.713c-15.931,0-28.669,3.443-37.862,10.233c-8.37,6.179-12.267,13.907-12.267,24.322v11.302 h-73.054l0.167-11.466c0.413-28.471,12.51-51.742,35.954-69.166c22.461-16.695,51.753-25.16,87.063-25.16 c36.752,0,66.085,8.711,87.185,25.89c21.793,17.751,32.842,42.258,32.842,72.843c0,30.085-16.092,59.634-47.829,87.825 l-0.243,0.21l-29.371,24.633c-10.808,10.282-16.061,25.059-16.061,45.166v11.302H197.618z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0A1930"
    },
    d: "M143.207,428.689c0.368,4.758-1.196,15.378,0.045,15.629h35.138c0,0,0.35-5.35-3.812-6.51 c-5.559-1.549-12.326-2.694-14.854-4.915c-1.248-1.096-1.853-4.204-1.853-4.204H143.207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7DBBF1",
      strokeWidth: 0.8477,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M168.75,436.322c0,0-4.465-0.404-6.065,2.137"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7DBBF1",
      strokeWidth: 0.8477,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M164.72,435.13c0,0-4.465-0.405-6.065,2.137"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0A1930"
    },
    d: "M122.73,428.689c-0.449,6.833,0.737,15.055-1.188,15.629H98.188c0,0-0.332-3.826,2.783-7.008 c1.276-1.304,4.291-2.795,5.66-4.169c1.243-1.247,1.436-4.452,1.436-4.452H122.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7DBBF1",
      strokeWidth: 0.8477,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M108.672,437.179c0,0-2.989-3.516-6.747-0.675"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7DBBF1",
      strokeWidth: 0.8477,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M112.348,435.395c0,0-4.477-3.682-7.901-0.805"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4A484"
    },
    d: "M168.71,238.646c1.015,6.3,0.684,13.031,1.003,12.698c0.838-0.904,10.846-5.817,11.648-6.229 c3.655-1.879,6.568-1.769,8.599-1.669c0.671,0.033,2.686-0.123,2.686-0.123s1.583-0.382,2.687,0.124 c1.117,0.505,1.432,1.382,0.399,1.726c-0.924,0.308-2.655,0.574-2.655,0.574s3.581-0.073,6.404-0.297 c1.062-0.084,1.183,1.358,1.183,1.358s0.448-0.066,0.673-0.116c1.438-0.317,1.994,1.84,1.42,2.005 c-0.963,0.278-1.623,0.364-1.623,0.364c0.362,0.142,0.996,1.143,0.089,1.41c-0.987,0.291-3.634,0.824-3.634,0.824 c0.627,0,1.148,1.209,0.783,1.342c-1.459,0.53-6.415,1.764-7.127,1.835c-0.632,0.063-3.87,0.027-5.306-0.199 c-1.143-0.173-3.564-0.731-3.564-0.731s-16.196,13.217-18.603,12.619c-1.782-0.452-5.213-2.58-5.771-5.758 c-0.572-3.191-4.413-22.144-4.413-22.144C155.09,228.699,167.173,229.112,168.71,238.646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#E08D68",
      strokeWidth: 0.5651,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M181.17,248.735c0,0-0.081,3.088,0.931,4.492"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#E08D68",
      strokeWidth: 0.5651,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M190.664,246.076c0,0-1.599,2.665-6.572,2.312c3.776,0.688,6.163,4.534,6.163,4.534"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#E08D68",
      strokeWidth: 0.5651,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 197.245,
    y1: 251.28,
    x2: 191.822,
    y2: 252.059
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#E08D68",
      strokeWidth: 0.5651,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 200.318,
    y1: 248.975,
    x2: 192.156,
    y2: 249.921
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#E08D68",
      strokeWidth: 0.5651,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 199.985,
    y1: 246.811,
    x2: 192.578,
    y2: 247.507
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#24292D"
    },
    d: "M153.658,171.374c0,0,1.502,1.568,1.866,5.045c0.364,3.477-2.346,8.094-2.346,8.094 L153.658,171.374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE5456"
    },
    d: "M163.831,285.516c1.135,10.778-5.003,144.617-5.003,144.617h-15.657 c0,0-4.909-95.209-4.248-109.102c0.661-13.892-2.343-27.07-1.459-35.516C138.348,277.071,161.915,267.335,163.831,285.516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE5456"
    },
    d: "M142.885,285.914c0.015,48.39-19.609,144.219-19.609,144.219h-16.137 c0,0,8.133-109.02,8.435-122.963c0.217-10.01,1.347-16.975,2.334-25.452C119.575,267.406,142.88,267.695,142.885,285.914z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.36,
      fill: "#FE5456"
    },
    d: "M163.93,295.62c-0.712-0.396-1.526-0.859-2.351-1.368 c-2.328-1.413-3.018-1.096-18.852-0.113c-0.204,0.011-0.407,0.023-0.622,0.034c-1.56,0.09-3.097,0.102-4.589,0.045 c-9.991-0.407-18.14-3.899-20.514-5.018c0.294-2.441,0.61-4.894,0.904-7.482c1.447-12.342,18.988-13.834,23.769-2.306 c7.087-5.459,20.717-7.55,22.152,6.103C163.975,286.94,163.997,290.5,163.93,295.62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#021946"
    },
    d: "M158.92,208.513c11.482,10.776,10.84,39.447,10.84,39.447s-10.573,7.028-16.862,4.286 c0,0-4.757-29.403-2.246-38.47C152.186,208.237,156.785,206.509,158.92,208.513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.36,
      fill: "#021946"
    },
    d: "M166.888,235.761c-0.154,5.498-0.112,10.671-0.427,14.085 c-3.628,1.854-9.494,4.17-13.563,2.396c0,0-4.758-29.397-2.249-38.462c0.678-2.419,1.933-4.114,3.311-5.075l4.962-0.192 c0,0,0.011,0.011,0.023,0.023C159.499,209.124,167.453,215.629,166.888,235.761z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#021946"
    },
    d: "M129.463,204.168c0,0-16.839,2.767-17.354,5.839c-0.515,3.072,5.894,47.361,5.894,57.757 c0,10.396-1.215,20.237-1.215,20.237s13.492,3.78,26.376,3.544c12.884-0.236,21.105-2.157,21.105-2.157 s-0.747-12.787-1.004-21.293c-0.257-8.506,1.753-33.319,1.773-42.409c0.018-7.906-3.697-14.363-6.119-17.173 c-2.001-2.322-12.523-4.765-12.523-4.765L129.463,204.168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.36,
      fill: "#021946"
    },
    d: "M121.433,264.324c-1.447,2.611-2.588,4.792-3.481,6.601 c0.034-1.04,0.045-2.102,0.045-3.165c0-6.906-2.837-28.787-4.577-43.581l13.02-7.55 C128.045,221.681,128.045,252.378,121.433,264.324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E08D68"
    },
    d: "M130.997,197.959l-1.534,6.246c0,0,6.612,11.019,14.417,9.917 c7.805-1.102,2.517-10.375,2.517-10.375l0.311-4.136l-14.398-8.534L130.997,197.959z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4A484"
    },
    d: "M154.42,174.355c0.407,2.072,0.235,8.834-0.171,14.055c-0.393,5.05-1.752,12.369-4.62,13.009 c-2.868,0.641-15.188-1.739-15.763-8.823c-2.099-1.657-10.075-11.423-7.266-16.256 C131.593,167.747,153.112,167.692,154.42,174.355z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#24292D"
    },
    cx: 144.36,
    cy: 184.981,
    rx: 0.857,
    ry: 1.28
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#24292D"
    },
    d: "M152.877,184.624c0,0.707-0.384,1.28-0.857,1.28c-0.473,0-0.857-0.573-0.857-1.28 s0.384-1.28,0.857-1.28C152.493,183.344,152.877,183.917,152.877,184.624z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#24292D"
    },
    d: "M145.8,181.863c-0.821-0.217-1.58-0.367-2.304-0.261c-0.73,0.079-1.368,0.475-2.061,0.979 c0.159-0.391,0.388-0.782,0.744-1.057c0.335-0.3,0.78-0.481,1.232-0.545C144.324,180.863,145.235,181.219,145.8,181.863z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#24292D"
    },
    d: "M149.598,181.506c0.565-0.644,1.476-1,2.389-0.883c0.451,0.064,0.896,0.245,1.232,0.545 c0.356,0.274,0.585,0.666,0.744,1.057c-0.693-0.504-1.331-0.9-2.061-0.979C151.178,181.138,150.419,181.288,149.598,181.506z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5744C"
    },
    d: "M148.971,186.505c0.12,0.738,0.522,1.401,0.878,2.061l1.128,1.984 c0.189,0.336,0.383,0.668,0.543,1.046c0.072,0.195,0.162,0.381,0.169,0.669c-0.005,0.085-0.002,0.16-0.049,0.282 c-0.044,0.114-0.084,0.142-0.13,0.214c-0.09,0.109-0.189,0.195-0.287,0.254c-0.39,0.25-0.772,0.351-1.163,0.429 c-0.388,0.075-0.776,0.115-1.172,0.097l-0.014-0.072c0.681-0.344,1.429-0.631,1.922-1.028c0.117-0.103,0.173-0.192,0.138-0.159 c-0.014-0.092-0.048-0.271-0.104-0.433c-0.106-0.336-0.245-0.688-0.39-1.034l-0.926-2.087c-0.272-0.711-0.592-1.434-0.617-2.22 L148.971,186.505z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M151.669,194.649c0,0-2.324-0.215-4.622,0.933c0,0,3.949,0.574,4.308,0.179 C151.715,195.367,151.669,194.649,151.669,194.649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#24292D"
    },
    d: "M154.803,176.15c-0.627,1.344-4.909,3.304-12.77,2.871c0,0,3.934-1.077,4.797-4.156 c0,0-3.168,4.849-9.336,4.725c0,0,0.543,4.331-2.119,8.78c0,0-1.772,2.342-1.509,4.225c0.247,1.77-1.627,4.933-2.869,5.651 c-0.748-5.602-6.614-16.554-5.472-22.724c1.155-6.24,6.784-6.349,6.784-6.349c2.562-4.074,12.026-5.745,18.198-2.379 C155.076,169.288,155.945,173.704,154.803,176.15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4A484"
    },
    d: "M136.018,186.454c-1.314-3.235-5.745-2.969-5.769-0.244c-0.039,4.476,2.66,5.802,3.617,6.386 C134.823,193.18,136.811,188.405,136.018,186.454z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4A484"
    },
    d: "M109.038,238.818c-1.015,6.3-1.868,12.495-2.187,12.163c-0.838-0.904-15.369-4.855-16.274-5.397 c-4.247-2.54-7.219-2.138-9.094-2.138l-2.686-0.123c0,0-1.583-0.382-2.687,0.124c-1.117,0.505-1.432,1.382-0.399,1.726 c0.924,0.308,2.655,0.574,2.655,0.574s-3.581-0.073-6.404-0.297c-1.062-0.084-1.183,1.358-1.183,1.358s-0.448-0.066-0.673-0.116 c-1.438-0.317-1.994,1.84-1.42,2.005c0.962,0.278,1.623,0.364,1.623,0.364c-0.362,0.142-0.996,1.143-0.089,1.41 c0.987,0.291,3.634,0.824,3.634,0.824c-0.627,0-1.148,1.209-0.783,1.342c1.459,0.53,6.416,1.764,7.127,1.835 c0.632,0.063,3.87,0.027,5.306-0.199C86.647,254.1,89.056,254,89.056,254s20.563,9.965,23.023,10.275 c2.229,0.281,5.938-0.506,7.133-3.872c1.085-3.055,5.594-21.664,5.594-21.664C123.303,229.178,110.574,229.283,109.038,238.818z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#E08D68",
      strokeWidth: 0.5651,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M89.317,253.763c0,0,0.967-1.33,1.209-3.183"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#E08D68",
      strokeWidth: 0.5651,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M80.778,246.076c0,0,1.599,2.665,6.572,2.312c-3.776,0.688-6.163,4.534-6.163,4.534"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#E08D68",
      strokeWidth: 0.5651,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 74.197,
    y1: 251.28,
    x2: 79.62,
    y2: 252.059
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#E08D68",
      strokeWidth: 0.5651,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 71.123,
    y1: 248.975,
    x2: 79.286,
    y2: 249.921
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#E08D68",
      strokeWidth: 0.5651,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 71.457,
    y1: 246.811,
    x2: 78.864,
    y2: 247.507
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#021946"
    },
    d: "M112.079,209.98c-5.583,11.137-5.777,36.293-5.777,36.293s11.01,5.729,17.556,3.073 c0,0,4.246-23.943,2.584-32.722C125.427,211.263,114.797,204.56,112.079,209.98z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE5456"
    },
    d: "M348.165,428.689c-0.368,4.758,1.196,15.378-0.045,15.629h-35.138c0,0-0.35-5.35,3.812-6.51 c5.559-1.549,12.326-2.694,14.854-4.915c1.248-1.096,1.853-4.204,1.853-4.204H348.165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7DBBF1",
      strokeWidth: 0.8477,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M322.621,436.322c0,0,4.465-0.405,6.065,2.137"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7DBBF1",
      strokeWidth: 0.8477,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M326.651,435.13c0,0,4.465-0.405,6.065,2.137"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE5456"
    },
    d: "M368.641,428.689c0.449,6.833-0.737,15.055,1.188,15.629h23.354c0,0,0.332-3.826-2.783-7.008 c-1.276-1.304-4.291-2.795-5.66-4.169c-1.243-1.247-1.435-4.452-1.435-4.452H368.641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7DBBF1",
      strokeWidth: 0.8477,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M382.699,437.179c0,0,2.989-3.516,6.747-0.675"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7DBBF1",
      strokeWidth: 0.8477,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M379.023,435.395c0,0,4.477-3.682,7.902-0.805"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#021946"
    },
    d: "M326.453,285.104c-1.135,10.778,6.424,145.029,6.424,145.029h15.656 c0,0,4.909-95.209,4.248-109.102c-0.661-13.892,2.343-27.07,1.459-35.516C353.357,277.071,328.369,266.923,326.453,285.104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#021946"
    },
    d: "M348.82,285.914c-0.015,48.39,19.609,144.219,19.609,144.219h16.137 c0,0-8.133-109.02-8.435-122.963c-0.217-10.01-1.347-16.975-2.334-25.452C372.13,267.406,348.825,267.695,348.82,285.914z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.36,
      fill: "#021946"
    },
    d: "M374.763,289.607c-2.713,1.198-10.76,4.329-20.559,4.363 c-0.904,0-1.831-0.023-2.758-0.079c-0.848-0.045-1.673-0.102-2.475-0.136c-11.822-0.622-18.332-0.35-20.378,0.215 c-0.802,0.215-1.548,0.893-2.159,1.673c-0.124-5.346-0.136-9.076,0.022-10.534c1.447-13.766,16.117-11.291,23.543-5.628 c1.175-2.882,3.142-4.95,5.459-6.25l11.167-0.814c3.685,1.401,6.623,4.555,7.177,9.302 C374.119,284.454,374.458,287.03,374.763,289.607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B84C1"
    },
    d: "M333.516,208.513c-11.482,10.776-10.84,39.447-10.84,39.447s10.573,7.028,16.862,4.286 c0,0,4.757-29.403,2.246-38.47C340.25,208.237,335.651,206.509,333.516,208.513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B84C1"
    },
    d: "M365.633,204.168c0,0,16.031,5.096,16.546,8.167c0.515,3.072-8.396,44.532-8.396,54.928 c0,10.396,1.134,20.738,1.134,20.738s-13.492,3.78-26.376,3.544c-12.884-0.236-22.526-2.569-22.526-2.569 s0.701-12.719,0.959-21.225c0.257-8.506,0.444-32.975,0.423-42.064c-0.018-7.906,3.697-14.363,6.119-17.173 c2.001-2.322,15.183-4.765,15.183-4.765L365.633,204.168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.36,
      fill: "#1B84C1"
    },
    d: "M373.78,267.263c0,2.893,0.09,5.775,0.215,8.431 c-2.565-5.052-7.392-9.697-9.844-10.477c-3.119-0.995-29.487-11.766-31.556-11.336c-1.108,0.226-3.447-0.079-5.38-0.418 c0.045-3.04,0.068-6.239,0.102-9.381l13.789-38.631c3.82-1.006,7.595-1.707,7.595-1.707c-1.13,0.904-2.701,6.047-3.854,8.601 c-1.164,2.554-7.493,29.329-7.493,29.329l21.542,2.136c2.69-20.548,8.488-28.832,8.488-28.832l12.817,10.816 C377.713,239.753,373.78,260.357,373.78,267.263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E08D68"
    },
    d: "M364.099,197.959l1.534,6.246c0,0-6.612,11.019-14.417,9.917 c-7.805-1.102-2.517-10.375-2.517-10.375l-0.311-4.136l14.398-8.534L364.099,197.959z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4A484"
    },
    d: "M341.24,174.432c-0.407,2.072-0.799,8.758-0.393,13.978c0.393,5.05,1.75,12.357,4.618,12.998 c2.868,0.641,15.19-1.728,15.765-8.811c2.099-1.657,10.074-11.423,7.266-16.256C363.503,167.747,342.547,167.769,341.24,174.432z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#24292D"
    },
    cx: 350.736,
    cy: 184.981,
    rx: 0.857,
    ry: 1.28
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#24292D"
    },
    cx: 343.245,
    cy: 184.477,
    rx: 0.857,
    ry: 1.28
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#24292D"
    },
    d: "M349.226,182.385c0.446-0.803,1.375-1.315,2.357-1.3c0.486,0.019,0.979,0.15,1.367,0.429 c0.402,0.252,0.701,0.625,0.894,1.037c-0.439-0.159-0.804-0.339-1.182-0.441c-0.369-0.119-0.733-0.174-1.096-0.178 C350.832,181.904,350.091,182.112,349.226,182.385z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#24292D"
    },
    d: "M346.092,181.881c-0.865-0.273-1.606-0.482-2.34-0.453c-0.364,0.004-0.727,0.059-1.097,0.178 c-0.378,0.103-0.743,0.283-1.182,0.441c0.193-0.412,0.492-0.785,0.894-1.037c0.388-0.279,0.881-0.41,1.367-0.429 C344.716,180.566,345.645,181.078,346.092,181.881z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E08D68"
    },
    d: "M346.199,186.507c-0.022,0.81-0.335,1.562-0.603,2.302l-0.917,2.174 c-0.144,0.361-0.283,0.726-0.389,1.078c-0.058,0.17-0.097,0.356-0.115,0.475c-0.006,0.033-0.004,0.049-0.006,0.057 c0,0-0.021-0.038,0.001-0.005c0.01,0.033,0.062,0.08,0.106,0.131c0.47,0.425,1.251,0.733,1.945,1.1l-0.015,0.074 c-0.409,0.016-0.81-0.031-1.211-0.117c-0.403-0.087-0.798-0.206-1.197-0.491c-0.101-0.079-0.197-0.168-0.282-0.307 c-0.039-0.044-0.094-0.174-0.108-0.274c-0.012-0.09-0.013-0.173-0.006-0.237c0.022-0.272,0.111-0.462,0.184-0.661 c0.163-0.385,0.355-0.734,0.544-1.083l1.123-2.072c0.355-0.69,0.753-1.383,0.871-2.147L346.199,186.507z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M343.195,195.578c0,0,2.257-0.833,4.555,0.316c0,0-3.949,0.574-4.308,0.18 C343.083,195.678,343.195,195.578,343.195,195.578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#24292D"
    },
    d: "M340.798,177.104c0.627,1.344,11.928,1.252,18.096,1.128c0,0-1.837,5.69,0.825,10.139 c0,0,1.772,2.342,1.51,4.225c-0.247,1.77,2.666,5.888,2.84,4.463c0.539-4.43,6.681-17.033,5.019-23.083 c-1.407-5.12-4.622-4.882-4.622-4.882c-2.562-4.074-8.933-1.878-21.734-4.698C337.649,163.277,339.657,174.657,340.798,177.104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4A484"
    },
    d: "M359.078,186.454c1.314-3.235,5.745-2.969,5.769-0.244c0.039,4.476-2.66,5.802-3.617,6.386 C360.273,193.18,358.285,188.405,359.078,186.454z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4A484"
    },
    d: "M325.818,250.967c1.933,0.677,2.485,0.835,3.269,0.856c1.924,0.05,3.193-0.095,3.193-0.095 s28.597,10.027,31.312,9.869c2.012-0.127,6.393-1.418,8.28-4.624c1.803-3.065,5.804-15.338,7.283-20.786 c2.782-10.243-10.909-11.865-14.496-1.899c-2.37,6.585-3.008,13.429-3.285,13.006c-0.72-1.144-24.492-3.559-24.976-4.422 c-0.952-1.698-4.366-2.466-5.337-2.508c-1.065-0.046-1.526-0.239-1.963-0.335c-1.313-0.288-2.45,0.989-1.178,1.558 c0.975,0.436,2.745,1.156,2.745,1.156s-6.119-2.182-7.295-2.625c-1.176-0.443-2.524,1.283-0.912,2.202 c1.612,0.918,1.935,1.056,1.935,1.056s-1.113-0.755-2.189-0.487c-0.721,0.18-0.3,2.208,0.497,2.445 c0.092,0.027,0.421,0.123,0.421,0.123s-1.55,1.566,0.627,2.353c0.177,0.064,0.37,0.131,0.37,0.131s-1.279,1.091-0.275,1.758 C324.848,250.364,325.818,250.967,325.818,250.967z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4A484"
    },
    d: "M345.552,208.124c-0.709,2.919-1.939,2.205-2.319,3.058c-0.403,0.904-8.048,29.789-8.329,31.111 c-0.906,4.266-6.303,7.614-9.41,6.203c-3.387-1.539-4.56-6.283-3.934-8.973c0.616-2.649,14.401-30.547,14.401-30.547 s1.044-8.694,1.59-9.003c1.521-0.862,4.36-1.863,4.715-1.935c1.026-0.209,5.86,0.031,5.83,0.001 c-0.03-0.03-0.07,1.118-0.856,1.626c-0.328,0.212-4.124,0.62-4.124,0.62s3.486,0.184,3.645,0.526 c0.159,0.342,0.568,4.29,0.414,4.728C346.656,207.021,345.63,207.831,345.552,208.124z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#E08D68",
      strokeWidth: 0.5651,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 339.964,
    y1: 200.951,
    x2: 341.633,
    y2: 200.556
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#E08D68",
      strokeWidth: 0.5651,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M340.292,202.452c0,0,4.918,0.064,5.066,0.187c0.148,0.123,0.492,2.303,0.855,2.635s0.549,0.296,0.549,0.296"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#E08D68",
      strokeWidth: 0.5651,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M339.52,204.387c0,0,4.018,0.443,4.263,0.554c0.245,0.111,0.689,2.365,1.464,2.402c0.776,0.037,0.966-0.85,0.966-0.85"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#E08D68",
      strokeWidth: 0.5651,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 339.758,
    y1: 206.365,
    x2: 343.03,
    y2: 206.863
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#E08D68",
      strokeWidth: 0.5651,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M341.922,207.897c-0.776,0.074-0.406,1.441,0,1.515c0.406,0.074,1.773,0.148,2.069,0c0.296-0.148,0.843-0.937,0.853-1.548 c0.005-0.285-0.445-1.499-0.445-1.499"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#E08D68",
      strokeWidth: 0.5651,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M343.777,210.584c0,0-1.803,1.052-4.527,0.562"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#E08D68",
      strokeWidth: 0.5651,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M342.867,211.71c0,0-0.799,0.515-2.575-0.134"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#E08D68",
      strokeWidth: 0.5651,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M342.772,197.982c0,0,5.097,0.057,5.325,0.056c0.228,0-0.209,1.464-0.856,1.626c-0.647,0.162-4.124,0.62-4.124,0.62 s3.575,0.243,3.645,0.526s0.274,1.828,0.274,1.828"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B84C1"
    },
    d: "M382.208,212.309c5.256,5.73-6.286,37.017-6.286,37.017s-8.985-0.615-15.531-3.271 c0,0,5.033-27.246,6.992-31.079C369.865,210.117,378.109,207.841,382.208,212.309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#E08D68",
      strokeWidth: 0.5651,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M335.056,241.673c-0.777,3.255-3.594,7.903-8.528,7.072c-4.086-0.688-4.887-5.874-4.887-5.874"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9205 -0.3906 0.3906 0.9205 -37.2654 47.3163)",
    style: {
      fill: "#DADEEA"
    },
    cx: 97.683,
    cy: 115.266,
    rx: 36.48,
    ry: 36.48
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M85.273,115.266c0,2.57-2.083,4.653-4.653,4.653s-4.653-2.083-4.653-4.653 c0-2.57,2.083-4.653,4.653-4.653S85.273,112.696,85.273,115.266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M102.336,115.266c0,2.57-2.083,4.653-4.653,4.653s-4.653-2.083-4.653-4.653 c0-2.57,2.083-4.653,4.653-4.653S102.336,112.696,102.336,115.266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M119.399,115.266c0,2.57-2.083,4.653-4.653,4.653c-2.57,0-4.653-2.083-4.653-4.653 c0-2.57,2.083-4.653,4.653-4.653C117.316,110.613,119.399,112.696,119.399,115.266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADEEA"
    },
    d: "M96.085,149.038c0,0,3.747,9.2,18.661,9.697c0,0-6.39-4.563-6.44-12.123L96.085,149.038z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9741 -0.2262 0.2262 0.9741 -22.1039 94.9345)",
    style: {
      fill: "#DADEEA"
    },
    cx: 403.172,
    cy: 143.912,
    rx: 36.48,
    ry: 36.48
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M415.582,143.912c0,2.57,2.083,4.653,4.653,4.653s4.653-2.083,4.653-4.653 c0-2.57-2.083-4.653-4.653-4.653S415.582,141.342,415.582,143.912z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M398.519,143.912c0,2.57,2.083,4.653,4.653,4.653c2.57,0,4.653-2.083,4.653-4.653 c0-2.57-2.083-4.653-4.653-4.653C400.602,139.259,398.519,141.342,398.519,143.912z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M381.456,143.912c0,2.57,2.083,4.653,4.653,4.653s4.653-2.083,4.653-4.653 c0-2.57-2.083-4.653-4.653-4.653S381.456,141.342,381.456,143.912z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADEEA"
    },
    d: "M404.77,177.684c0,0-3.747,9.2-18.661,9.697c0,0,6.39-4.563,6.44-12.123L404.77,177.684z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48BE97"
    },
    d: "M193.757,444.318c0,0,0.559-13.946-12.599-24.35c0,0,18.381,2.037,19.876,24.349L193.757,444.318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36A871"
    },
    d: "M195.699,444.317c0,0-1.728-23.116,18.879-27.89c0,0-11.848,8.339-13.026,27.89H195.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48BE97"
    },
    d: "M195.699,444.317c0,0,4.684-20.615,24.198-19.878c0,0-14.77,8.293-15.627,19.878H195.699z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48BE97"
    },
    d: "M294.71,444.318c0,0-2.62-8.717,9.025-13.447c0,0-13.167-2.536-14.238,13.447L294.71,444.318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36A871"
    },
    d: "M293.319,444.317c0,0-2.426-9.73,2.607-21.844c0,0-9.331,4.585-6.799,21.844H293.319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48BE97"
    },
    d: "M293.319,444.317c0,0-0.751-11.136-14.73-10.608c0,0,10.007,3.238,8.59,10.608H293.319z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhychooseus);
export default __webpack_public_path__ + "static/media/why choose us.d63cf462a7f18609e6f4b5dddb1446f2.svg";
export { ForwardRef as ReactComponent };